/* eslint-disable import/prefer-default-export */
import TagManager from 'react-gtm-module';
import { store } from "../../redux/store";

// Save original gtm() implementation
const originalGtm = TagManager.gtm

/**
 * We are monkey-patching the TagManager module
 * so that we can add a Cookiebot data-cookieconsent="ignore" attribute
 * that will allow tag manager to load without being auto-blocked,
 * since it conforms to consent protocols and can integrate with Cookiebot
 * consent mechanisms without aggressive blocking.
 */
// eslint-disable-next-line func-names
TagManager.gtm = function(args) {
  const result = originalGtm.call(this, args)

  // Wrap the script() method to add data-cookieconsent="ignore"
  const originalScript = result.script
  result.script = () => {
    const script = originalScript()
    script.setAttribute('data-cookieconsent', 'ignore')
    return script
  }

  const originalNoScript = result.noScript
  result.noScript = () => {
    const noscript = originalNoScript()
    noscript.setAttribute('data-cookieconsent', 'ignore')
    return noscript
  }

  return result
};

export const gtmDataLayer = (args) => {
  const siteSettings = store?.getState()?.siteSettings;
  if (siteSettings?.dataCollectionDelay) {
    setTimeout(() => {
      TagManager.dataLayer(args);
    }, siteSettings.dataCollectionDelay);
  } else {
    TagManager.dataLayer(args);
  }
}

export { TagManager }
export default TagManager
